const EPSILON = 0.001

// array of numbers from 0 to n
export function range(n: number): number[] {
  return Array(n).fill(1).map((_, i) => i)
}

export function eq(a: number, b: number): boolean {
  return Math.abs(a - b) < EPSILON
}

export function gt(a: number, b: number): boolean {
  return (a + EPSILON) > (b - EPSILON)
}

export function lt(a: number, b: number): boolean {
  return (a - EPSILON) < (b + EPSILON)
}

export function length(x: number, y: number): number {
  return Math.sqrt(x * x + y * y)
}

export function snap(n: number, step: number): number {
  return Math.floor(n / step) * step
}
